import {MediaController} from "./mediacontroller.js";
export default MediaController